var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[(_vm.label)?_c('label',{attrs:{"for":_vm.getId}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":_vm.getId,"name":_vm.name,"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }